import React, { useMemo } from 'react'
import {
  buildPanelCheckItems,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseExtraFiltersInputs'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'

interface Props {
  cruiseTypes?: Set<string>
  onChange: (value: any) => void
  facets: Array<App.CruiseSearchFacet>
}

function CruiseCruiseTypeFilter({
  cruiseTypes,
  onChange,
  facets,
}: Props) {
  const { cruiseTypeItems, hasCruiseTypes } = useMemo(() => {
    const cruiseTypeFacets = facets.filter(facet => facet.category === 'cruise_types')

    return {
      cruiseTypeItems: buildPanelCheckItems(cruiseTypeFacets),
      hasCruiseTypes: cruiseTypeFacets.some(facet => !!facet.count),
    }
  }, [facets])

  if (!hasCruiseTypes) {
    return null
  }

  return <div data-testid="cruise-type-filter">
    <FilterPanelCheckboxGroup
      name="cruiseTypes"
      items={cruiseTypeItems}
      onChange={onChange}
      defaultSelected={cruiseTypes}
    />
  </div>
}

export default CruiseCruiseTypeFilter
